import SihaDownloadDocumentRequestModelBase from '../_generated/modelBases/siha-download-document-request-model-base';

export default class SihaDownloadDocumentRequestModel extends SihaDownloadDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
